import cookie from "./base";

import {
  ACCESS_TOKEN_KEY,
  ACCESS_TOKEN_EXPIRED_AT_KEY,
  ACCESS_TOKEN_EXPIRED_TIME_KEY,
  REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_EXPIRED_AT_KEY,
  REFRESH_TOKEN_EXPIRED_TIME_KEY,
} from "./const";

const { getCookie, setCookie, eraseCookie } = cookie;

const authCookie = {
  getAccessToken: () => getCookie(ACCESS_TOKEN_KEY),

  getAccessTokenExpiredAt: () => getCookie(ACCESS_TOKEN_EXPIRED_AT_KEY),

  getAccessTokenExpiredTime: () => getCookie(ACCESS_TOKEN_EXPIRED_TIME_KEY),

  getRefreshToken: () => getCookie(REFRESH_TOKEN_KEY),

  getRefreshExpiredAt: () => getCookie(REFRESH_TOKEN_EXPIRED_AT_KEY),

  getRefreshExpiredTime: () => getCookie(REFRESH_TOKEN_EXPIRED_TIME_KEY),

  setAccessToken: (token: string) => {
    setCookie(ACCESS_TOKEN_KEY, token);
  },

  setAccessTokenExpiredAt: (seconds: string) => {
    setCookie(ACCESS_TOKEN_EXPIRED_AT_KEY, seconds);
  },

  setAccessTokenExpiredTime: (seconds?: string) => {
    setCookie(ACCESS_TOKEN_EXPIRED_TIME_KEY, seconds);
  },

  setRefreshToken: (token: string, seconds?: number) => {
    setCookie(REFRESH_TOKEN_KEY, token, seconds);
  },

  setRefreshTokenExpiredAt: (seconds: string) => {
    setCookie(REFRESH_TOKEN_EXPIRED_AT_KEY, seconds);
  },

  setRefreshTokenExpiredTime: (seconds?: string) => {
    setCookie(REFRESH_TOKEN_EXPIRED_TIME_KEY, seconds);
  },

  reset: () => {
    eraseCookie(ACCESS_TOKEN_KEY);
    eraseCookie(REFRESH_TOKEN_KEY);
    eraseCookie(ACCESS_TOKEN_EXPIRED_TIME_KEY);
    eraseCookie(REFRESH_TOKEN_EXPIRED_TIME_KEY);
  },
};

export default authCookie;
